<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">
          {{ empresa.nombrec }}
          <small class="title is-5"
            >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
          >
          <small class="subtitle is-7">{{ empresa.nombre }}</small>
        </h1>
        <div class="columns">
          <div class="column is-2">
            <div class="field has-addons">
              <p class="control">
                <button class="button is-primary" @click="selectyear('-')">
                  <span class="icon">
                    <span class="material-icons">keyboard_arrow_left</span>
                  </span>
                </button>
              </p>
              <p class="control">
                <button class="button">
                  <span>{{ year }}</span>
                </button>
              </p>
              <p class="control">
                <button class="button is-primary" @click="selectyear('+')">
                  <span class="icon">
                    <span class="material-icons">keyboard_arrow_right</span>
                  </span>
                </button>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="buttons has-addons">
              <span
                class="button"
                @click="selectedmes(0)"
                :class="{ 'is-primary': buttonSel(0) }"
                >Ene</span
              >
              <span
                class="button"
                @click="selectedmes(1)"
                :class="{ 'is-primary': buttonSel(1) }"
                >Feb</span
              >
              <span
                class="button"
                @click="selectedmes(2)"
                :class="{ 'is-primary': buttonSel(2) }"
                >Mzo</span
              >
              <span
                class="button"
                @click="selectedmes(3)"
                :class="{ 'is-primary': buttonSel(3) }"
                >Abr</span
              >
              <span
                class="button"
                @click="selectedmes(4)"
                :class="{ 'is-primary': buttonSel(4) }"
                >May</span
              >
              <span
                class="button"
                @click="selectedmes(5)"
                :class="{ 'is-primary': buttonSel(5) }"
                >Jun</span
              >
              <span
                class="button"
                @click="selectedmes(6)"
                :class="{ 'is-primary': buttonSel(6) }"
                >Jul</span
              >
              <span
                class="button"
                @click="selectedmes(7)"
                :class="{ 'is-primary': buttonSel(7) }"
                >Ago</span
              >
              <span
                class="button"
                @click="selectedmes(8)"
                :class="{ 'is-primary': buttonSel(8) }"
                >Sep</span
              >
              <span
                class="button"
                @click="selectedmes(9)"
                :class="{ 'is-primary': buttonSel(9) }"
                >Oct</span
              >
              <span
                class="button"
                @click="selectedmes(10)"
                :class="{ 'is-primary': buttonSel(10) }"
                >Nov</span
              >
              <span
                class="button"
                @click="selectedmes(11)"
                :class="{ 'is-primary': buttonSel(11) }"
                >Dic</span
              >
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="notification is-link">
              <h4 class="title is-4">Margen acumulado {{ year }}</h4>
              <h4 class="subtitle is-4">
                {{ (sumaIngresos.year1 - sumaGastos.year1) | number(2) }}
                millones
                <br />
                <span class="subtitle is-5"
                  >{{
                    (((sumaIngresos.year1 - sumaGastos.year1) /
                      sumaIngresos.year1) *
                      100)
                      | number(2)
                  }}%</span
                >
              </h4>
            </div>
          </div>
          <div class="column">
            <div
              class="notification"
              :class="{
                'is-primary': notification,
                'is-danger': !notification,
              }"
            >
              <h4 class="title is-4">Diferencia margen</h4>
              <h4 class="subtitle is-4">
                {{
                  (sumaIngresos.year1 -
                    sumaGastos.year1 -
                    (sumaIngresos.year0 - sumaGastos.year0))
                    | number(2)
                }}
                millones
                <br />
                <span class="subtitle is-5"
                  >Ing
                  {{
                    (((sumaIngresos.year1 - sumaIngresos.year0) /
                      sumaIngresos.year0) *
                      100)
                      | number(2)
                  }}% Gtos
                  {{
                    (((sumaGastos.year1 - sumaGastos.year0) /
                      sumaGastos.year0) *
                      100)
                      | number(2)
                  }}%</span
                >
              </h4>
            </div>
          </div>
          <div class="column">
            <div class="notification is-light">
              <h4 class="title is-4">Margen acumulado {{ year - 1 }}</h4>
              <h4 class="subtitle is-4">
                {{ (sumaIngresos.year0 - sumaGastos.year0) | number(2) }}
                millones
                <br />
                <span class="subtitle is-5"
                  >{{
                    (((sumaIngresos.year0 - sumaGastos.year0) /
                      sumaIngresos.year0) *
                      100)
                      | number(2)
                  }}%</span
                >
              </h4>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="box">
              <h4 class="title is-4">Ingresos</h4>
              <span class="tag is-light is-large"
                >${{ sumaIngresos.year0 | number(2) }} millones</span
              >
              <span class="tag is-link is-large"
                >${{ sumaIngresos.year1 | number(2) }} millones</span
              >
              <span class="has-text-grey-light"
                >a {{ labels[mesSelected] }} de {{ year }}</span
              >
              <br />
              <br />
              <y-graph
                :datagraph="dataIngresos"
                :cambio="cambio"
                :height="200"
              ></y-graph>
            </div>
          </div>
          <div class="column">
            <div class="box">
              <h4 class="title is-4">Gastos</h4>
              <span class="tag is-light is-large"
                >${{ sumaGastos.year0 | number(2) }} millones</span
              >
              <span class="tag is-danger is-large"
                >${{ sumaGastos.year1 | number(2) }} millones</span
              >
              <span class="has-text-grey-light"
                >a {{ labels[mesSelected] }} de {{ year }}</span
              >
              <br />
              <br />
              <y-graph
                :datagraph="dataGastos"
                :cambio="cambio"
                :height="200"
              ></y-graph>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
import yGraph from "@/components/dashboard/Graph.vue";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      year: null,
      cambio: 0,
      dataIngresos: {},
      sumaIngresos: {},
      dataGastos: {},
      sumaGastos: {},
      mesSelected: new Date().getMonth(),
      dataNow: new Date(),
      data: {},
      labels: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
    };
  },
  computed: {
    ...mapState(["empresa"]),
    notification() {
      if (
        this.sumaIngresos.year1 -
          this.sumaGastos.year1 -
          (this.sumaIngresos.year0 - this.sumaGastos.year0) <
        0
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    selectyear(sign) {
      if (sign === "+") {
        this.year++;
      } else {
        this.year--;
      }
      this.traeData(this, this.year);
    },
    selectedmes(n) {
      this.mesSelected = n;
      let dataIngresos;
      let dataGastos;
      dataIngresos = this.organizaData(
        this.data,
        ["#3273dc", "#e5e5e5"],
        ["4"],
        this,
        1,
        this.mesSelected
      );
      this.dataIngresos = dataIngresos.data;
      this.sumaIngresos = dataIngresos.totales;
      dataGastos = this.organizaData(
        this.data,
        ["#ff3860", "#e5e5e5"],
        ["5", "6", "7"],
        this,
        -1,
        this.mesSelected
      );
      this.dataGastos = dataGastos.data;
      this.sumaGastos = dataGastos.totales;
      this.cambio++;
    },
    async traeData(_this, year) {
      let result;
      let dataIngresos;
      let dataGastos;
      try {
        if (year) {
          this.year = year;
        } else {
          const today = new Date();
          this.year = today.getFullYear();
        }
        result = await apiServices.get(`/dashboard/${this.year}`);
        _this.data = result.data;
        dataIngresos = _this.organizaData(
          result.data,
          ["#3273dc", "#e5e5e5"],
          ["4"],
          _this,
          1,
          _this.mesSelected
        );
        _this.dataIngresos = dataIngresos.data;
        _this.sumaIngresos = dataIngresos.totales;
        dataGastos = _this.organizaData(
          result.data,
          ["#ff3860", "#e5e5e5"],
          ["5", "6", "7"],
          _this,
          -1,
          _this.mesSelected
        );
        _this.dataGastos = dataGastos.data;
        _this.sumaGastos = dataGastos.totales;
        _this.cambio++;
      } catch (err) {
        console.log(err);
      }
    },
    organizaData(data, colors, cuentas, _this, mult, mes) {
      let returnData = {};
      returnData.typeGraphic = "bar";
      returnData.colors = colors;
      returnData.datasetOverride = [{ type: "bar" }, { type: "line" }];
      returnData.labels = _this.labels;

      let totales = {
        year0: 0,
        year1: 0,
      };
      returnData.options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
        },
      };
      if (data.length > 0) {
        let years = []; // aqui guardamos los años
        let datasets = {};
        data.forEach(function (k, v) {
          if (cuentas.indexOf(k._id.scuenta) !== -1) {
            if (years.indexOf(k._id.year) === -1) {
              years.push(k._id.year);
              datasets[k._id.year] = {
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              };
              datasets[k._id.year].data[parseInt(k._id.mes) - 1] +=
                (-k.valor / 1000000) * mult;
            } else {
              datasets[k._id.year].data[parseInt(k._id.mes) - 1] +=
                (-k.valor / 1000000) * mult;
            }
          }
        });
        if (!datasets[_this.year]) {
          datasets[_this.year] = {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          };
        }
        if (!datasets[_this.year - 1]) {
          datasets[_this.year - 1] = {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          };
        }
        years = [_this.year, _this.year - 1];
        returnData.data = [];
        const largonow = mes + 1;
        for (let i = 0; i < largonow; i++) {
          totales.year0 += datasets[years[1]].data[i];
          totales.year1 += datasets[years[0]].data[i];
        }
        returnData.series = years;
        returnData.data[0] = datasets[years[0]].data;
        returnData.data[1] = datasets[years[1]].data;
        returnData.data[0].forEach(function (k, v) {
          if (v > mes) {
            returnData.data[0][v] = 0;
          }
        });
      }
      return {
        data: returnData,
        totales: totales,
      };
    },
    buttonSel(n) {
      if (n <= this.mesSelected) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    empresa(newv, oldv) {
      if (oldv._id !== newv._id) {
        if (oldv._id !== "no id") {
          this.traeData(this);
        }
      }
    },
  },
  created() {
    this.traeData(this);
  },
  components: {
    yGraph,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue